<template>
    <div class="main-panel">
        <div class="content-wrapper dashboard-shell">
            <div class="cardplay pagos-card horizontal-scrollable">
                <div class="row dashboard-header gx-3 gy-0 align-items-center mb-4">
                    <div class="col-lg-8 col-md-7">
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <span class="header-icon"><i class="fa-solid fa-money-bill-transfer"></i></span>
                            <h2 class="dashboard-title mb-0">Pagos y refinanciamientos</h2>
                        </div>
                        <p class="pagos-subtitle mb-0">
                            Consulta movimientos por rango de fechas y exporta la información en Excel.
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-5 d-flex justify-content-md-end justify-content-start">
                        <div class="btn-group module-toggle" role="group" aria-label="Opciones de pagos">
                            <button @click="selectOption(true)" class="btn btn-outline-secondary"
                                :class="pagoOption ? 'active' : ''" type="button">
                                Pagos
                            </button>
                            <button @click="selectOption(false)" class="btn btn-outline-secondary"
                                :class="!pagoOption ? 'active' : ''" type="button">
                                Refinanciamientos
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row g-3 mb-3">
                    <div class="col-lg-6 col-md-7" v-if="pagoOption">
                        <div class="summary-chip h-100">
                            <p class="chip-label">Rango de consulta</p>
                            <VueDatePicker v-model="date" :range="true" rangeSeparator=" a " locale="es"></VueDatePicker>
                        </div>
                    </div>
                    <div :class="pagoOption ? 'col-lg-6 col-md-5' : 'col-12'">
                        <div class="summary-chip summary-info d-flex align-items-center h-100">
                            <i class="fa-solid fa-circle-info me-2"></i>
                            <span v-if="pagoOption">Filtra por fechas para visualizar únicamente los pagos del periodo seleccionado.</span>
                            <span v-else>Visualizando historial consolidado de refinanciamientos registrados.</span>
                        </div>
                    </div>
                </div>

                <TablaPagos :key="`${date[0]}-${date[1]}-${pagoOption}`" :startDate="date[0]" :endDate="date[1]"
                    :option="pagoOption" />
            </div>
        </div>
    </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import TablaPagos from './Tabla-Pagos.vue';

export default {
    components: {
        VueDatePicker,
        TablaPagos
    },
    data() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return {
            date: [today, today],
            pagoOption: true,
        };

    },
    methods: {
        selectOption(option) {
            this.pagoOption = option;
        }
    }

}
</script>

<style scoped>
.dashboard-shell {
    background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
    min-height: 100vh;
}

.cardplay {
    border-radius: 24px;
    border: 1px solid #e5e7eb;
    padding: 32px;
    background-color: #ffffff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
    background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
    border-radius: 18px;
    color: #fff;
    padding: 16px 18px;
}

.header-icon {
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
}

.dashboard-title {
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.4px;
}

.pagos-subtitle {
    color: #e5e7eb;
    font-size: 0.95rem;
}

.module-toggle {
    border-radius: 12px;
    overflow: hidden;
}

.btn-outline-secondary {
    border-color: #d1d5db;
    color: #111827;
    background: #fff;
    font-weight: 600;
}

.btn-outline-secondary.active,
.btn-outline-secondary:active,
.btn-outline-secondary:hover {
    color: #fff;
    background: #111827;
    border-color: #111827;
}

.summary-chip {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 14px;
}

.chip-label {
    margin-bottom: 8px;
    color: #64748b;
    font-size: 0.82rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.35px;
}

.summary-info {
    color: #334155;
    font-size: 0.92rem;
}
</style>
